import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideMatSelectSearchOptions } from 'ngx-mat-select-search';

import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';
import { PortalDateAdapter } from './services/portal-date-adapter';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    // The native date formats, but with an adapter that takes its locale from
    // SettingsService instead of `DateAdapter.setLocale()`.
    { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS },
    { provide: DateAdapter, useClass: PortalDateAdapter },
    provideCharts(withDefaultRegisterables()),
    // The library's labels default to German ('Suche', 'Keine Optionen
    // gefunden'). The placeholder is set per field, since it names the field.
    provideMatSelectSearchOptions({
      noEntriesFoundLabel: 'No matches'
    })
  ]
};
